export enum ClientsSources {

  /**
   * Оформление заказ-наряда
   */
  ORDER = 'order',

  /**
   * Продажа лиду
   */
  LEAD = 'lead',

  /**
   * Ручное добавление
   */
  CREATE = 'create',
}

export const ClientsSourcesTranslate: Record<string, string> = {
  [ClientsSources.ORDER]: 'Оформление заказ-наряда',
  [ClientsSources.LEAD]: 'Продажа лиду',
  [ClientsSources.CREATE]: 'Ручное добавление',
};
